{
  "fr": {
    "ai": {
      "assistant": {
        "all_projects": "Tous les projets",
        "cap": {
          "action": "Démarrer une nouvelle conversation",
          "message": "Vous avez atteint la limite de conversation."
        },
        "empty_state": {
          "subtitle": "Posez-moi n'importe quelle question sur vos clients",
          "title": "Comment puis-je vous aider ?"
        },
        "errors": {
          "budget_reached": "Le budget IA de ce mois est épuisé. Contactez Ziggu pour l'augmenter.",
          "generic": "Une erreur s'est produite. Veuillez réessayer."
        },
        "history": {
          "empty": "Aucune conversation passée",
          "title": "Conversations passées"
        },
        "input": {
          "disclaimer": "Les résultats peuvent être inexacts. Vérifiez toujours les informations importantes.",
          "hint": "Entrée pour envoyer · Maj+Entrée pour nouvelle ligne",
          "placeholder": "Posez une question sur vos clients..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Comment configurer les notifications ?",
          "help_project_settings": "Où trouver les paramètres du projet ?",
          "open_decisions": "Quelles décisions sont encore ouvertes ?",
          "unassigned_units": "Quelles units n'ont pas encore de client ?"
        },
        "support_cta": {
          "action": "Contacter le support",
          "prompt": "Ce n'est pas la réponse que vous cherchiez ?"
        }
      },
      "dashboard": {
        "agents": {
          "all": "Tous les modules",
          "assistant": "Assistant",
          "conversation_agent": "Agent conversationnel",
          "label": "Module"
        },
        "clients": {
          "allowance_split": "Gratuit {free} · Payant {paid}",
          "columns": {
            "allowance": "Budget",
            "chats": "Conversations sur la période",
            "client": "Client",
            "spend": "Dépenses sur la période",
            "status": "Statut",
            "used": "Utilisé ce mois-ci"
          },
          "empty": "Aucun client n'a utilisé l'IA sur cette période",
          "export": "Exporter",
          "title": "Clients"
        },
        "empty_hint": "Aucun résultat pour ce module et cette période.",
        "intent_mix": {
          "empty": "Aucune conversation sur cette période",
          "row": "{chats} conversation · {amount} | {chats} conversations · {amount}",
          "title": "Répartition par intention"
        },
        "intents": {
          "draft": "Rédiger une réponse",
          "none": "Sans intention",
          "question": "Demander",
          "summary": "Résumé"
        },
        "kpi": {
          "clients_active": "Clients actifs",
          "employees_active": "Collaborateurs actifs",
          "spend_month": "Dépenses ce mois-ci",
          "spend_month_detail": "Mois calendaire en cours",
          "spend_range": "Dépenses sur la période",
          "spend_range_detail": "{count} conversation sur cette période | {count} conversations sur cette période",
          "spend_today": "Dépenses aujourd'hui",
          "tickets_assisted": "Tickets assistés"
        },
        "load_failed": {
          "description": "Rechargez la page ou choisissez une autre période.",
          "title": "Impossible de charger l'utilisation de l'IA"
        },
        "range": {
          "label": "Période"
        },
        "spend": {
          "empty": "Aucune dépense sur cette période",
          "monthly_empty": "Aucune dépense sur les {months} derniers mois",
          "monthly_hint": "{months} derniers mois · indépendant de la période sélectionnée",
          "monthly_title": "Coût par mois",
          "monthly_total": "{amount} sur les {months} derniers mois · indépendant de la période sélectionnée",
          "title": "Dépenses par jour",
          "total": "{amount} sur la période",
          "view": {
            "label": "Afficher les dépenses",
            "per_day": "Par jour",
            "running_total": "Cumul"
          }
        },
        "status": {
          "over": "Budget dépassé",
          "over_days": "Dépassé · 1 jour | Dépassé · {count} jours"
        },
        "title": "Utilisation de l'IA"
      },
      "settings": {
        "budget": {
          "description": "Plafond mensuel pour l'utilisation de l'IA (phase de test). Recalculé en fonction de la consommation de tokens sur toutes les conversations ce mois-ci.",
          "free_label": "Budget gratuit",
          "override_help": "Laissez vide pour utiliser le montant du forfait ({amount}).",
          "override_label": "Budget gratuit personnalisé",
          "paid_label": "Budget payant",
          "save": "Enregistrer",
          "title": "Budget mensuel",
          "total_label": "Budget total",
          "usage_label": "Utilisé ce mois-ci",
          "use_package_amount": "Utiliser le montant du forfait"
        },
        "description": "Configuration des fonctionnalités IA dans votre organisation.",
        "title": "Paramètres IA",
        "usage": {
          "description": "La part du crédit IA de ce mois-ci déjà utilisée. À 100 %, les fonctionnalités IA s'arrêtent jusqu'à la remise à zéro le mois prochain.",
          "title": "Utilisation de l'IA"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Ajuster",
          "ask": "Demander",
          "draft": "Rédiger une réponse",
          "draft_empty": "Pas encore de messages auxquels répondre",
          "follow_up": "Question de suivi",
          "follow_up_stop": "Arrêter le suivi",
          "new": "Nouvelle question",
          "summary": "Résumer la conversation",
          "summary_empty": "Pas encore de messages à résumer",
          "use_as_reply": "Utiliser comme réponse"
        },
        "adjusting_draft": "Ajustement de ce brouillon",
        "beta": "Bêta",
        "budget": {
          "description": "Le budget IA de ce mois est épuisé. Les réponses précédentes restent disponibles.",
          "request": "Nous avons épuisé le budget IA de ce mois et souhaitons l'augmenter.",
          "request_low": "Nous avons presque épuisé le budget IA de ce mois et souhaitons l'augmenter.",
          "title": "Budget IA atteint",
          "warn": "{percent} % du budget IA de ce mois utilisé."
        },
        "cap": "Cette discussion est devenue longue. Posez plutôt une nouvelle question.",
        "collapse": "Masquer l'assistant",
        "conversation": "Conversation",
        "digest": {
          "decisions_open": "aucune décision ouverte | 1 décision ouverte | {count} décisions ouvertes",
          "installments_unpaid": "aucune tranche impayée | 1 tranche impayée | {count} tranches impayées",
          "issues_open": "aucun point d’après-vente ouvert | 1 point d’après-vente ouvert | {count} points d’après-vente ouverts",
          "nothing_open": "Rien en suspens pour cette unité",
          "overdue": "{count} en retard",
          "title": "En un coup d'œil"
        },
        "earlier_answers": "Réponses précédentes",
        "empty": "Posez une question sur cette conversation, ou commencez par l'une de celles-ci.",
        "expand": "Afficher l'assistant",
        "following_up": "Suivi de cette réponse",
        "footer": "Visible uniquement par vous. Les réponses sont générées par une IA et peuvent contenir des erreurs.",
        "input": {
          "adjust_draft": "Ajuster ce brouillon, p. ex. plus court ou plus formel",
          "follow_up": "Poser une question de suivi",
          "label": "Votre question",
          "placeholder": "Question sur cette conversation"
        },
        "links": {
          "aftercare": "Après-vente",
          "decisions": "Décisions",
          "financials": "Finances"
        },
        "placeholders": {
          "confirm": {
            "accept": "Envoyer quand même",
            "header": "Envoyer avec des éléments à compléter ?",
            "message": "L’assistant a laissé 1 élément à compléter dans cette réponse. | L’assistant a laissé {count} éléments à compléter dans cette réponse."
          },
          "remaining": "1 élément à compléter | {count} éléments à compléter"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Remplacer",
            "header": "Remplacer votre texte ?",
            "message": "Le brouillon remplace le texte de la zone de réponse."
          }
        },
        "suggestions": {
          "history": "Quel est l'historique avec ce client ?",
          "issues_open": "Combien de points d'après-vente restent ouverts ?",
          "undecided": "Qu'est-ce que ce client n'a pas encore décidé ?"
        },
        "thinking": "L'assistant travaille...",
        "title": "Assistant"
      }
    }
  }
}
